module.exports = __webpack_public_path__ + "static/img/lastVideo.424b58a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/lastVideo.gif
// module id = vEec
// module chunks = 56